import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate"
import { Popups } from "ui/types/popups";

export const NoAdsPopup = () => {
    const handleCloseBtnClick = () => {
        (window as any)?.dataLayer?.push({
            event: "stories_no_ads_banner_close",
        });
        GameUI.closePopup(Popups.NO_ADS_POPUP);
    }

    return (
        <div id="no_ads" role="tooltip" className="modals_area active">
            <div className="wrapper">
                {/* <button type="button" class="close_btn close"></button> */}
                <div className="text_content">
                    <span className="modals_area-title">{translate("no_ads_title")}</span>
                    <p className="modals_area-text">{translate("no_ads_text")}</p>
                    <button id="closing-ignore-el" type="button" className="modals_area-btn" onClick={handleCloseBtnClick}>{translate("close_text")}</button>
                </div>
            </div>
        </div>
    )
}